import { HomeOutlined } from '@ant-design/icons';
import { AiOutlineMoneyCollect } from 'react-icons/ai';
import { FaBook, FaBoxOpen, FaBroom, FaMailBulk } from 'react-icons/fa';
import { FcInTransit } from 'react-icons/fc';
import { HiMiniRectangleStack, HiOutlineQueueList } from 'react-icons/hi2';
import { IoMdPricetags } from 'react-icons/io';
import { LuMailSearch } from 'react-icons/lu';
import {
	MdEmail,
	MdOutlineAdminPanelSettings,
	MdPriceChange,
} from 'react-icons/md';
import { PiMicrosoftOutlookLogoFill } from 'react-icons/pi';
import { RiContactsBook2Fill, RiContactsFill } from 'react-icons/ri';
import { SiBrandfolder, SiGmail } from 'react-icons/si';
import { GiLion } from 'react-icons/gi';
import {
	TbFileInvoice,
	TbFileStack,
	TbReplace,
	TbReport,
	TbReportMoney,
	TbShoppingCartDollar,
	TbSpeakerphone,
} from 'react-icons/tb';
import { TfiHeadphoneAlt } from 'react-icons/tfi';
import { BsBoxSeamFill } from 'react-icons/bs';
import { FaMicrochip } from 'react-icons/fa6';

import HouseAccount from '../images/HouseAccount.png';

export const avatarBgColor = {
	A: '#1ABC9C',
	B: '#16A085',
	C: '#F1C40F',
	D: '#F39C12',
	E: '#2ECC71',
	F: '#27AE60',
	G: '#EF8D4D',
	H: '#D35400',
	I: '#3498DB',
	J: '#2980B9',
	K: '#E74C3C',
	L: '#C0392B',
	M: '#9B59B6',
	N: '#8E44AD',
	O: '#BDC3C7',
	P: '#34495E',
	Q: '#34495E',
	R: '#95A5A6',
	S: '#7F8C8D',
	T: '#EC87BF',
	U: '#D870AD',
	V: '#F69785',
	W: '#9BA37E',
	X: '#C9A669',
	Y: '#B49255',
	Z: '#001433',
	default: '#A94136',
};

function getItem(label, key, icon, children, disabled) {
	return {
		key,
		icon,
		children,
		label,
		disabled,
	};
}

export const defaultRoutes = [
	getItem('Home', '/', <HomeOutlined />),
	getItem(
		'Help Desk',
		'/help-desk',
		<TfiHeadphoneAlt style={{ fontSize: '18px' }} />,
	),
];

export const routes = [
	getItem('Home', '/', <HomeOutlined />),
	getItem(
		'Help Desk',
		'/help-desk',
		<TfiHeadphoneAlt style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Backorder Management',
		'/backorder-management',
		<FaBoxOpen style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Bobcat: Supplier Prices',
		'/supplier-prices',
		<AiOutlineMoneyCollect style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Bom Cleaner',
		'/bom-cleaner',
		<FaBroom style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Bounceback Tracker',
		'/bounceback-tracker',
		<LuMailSearch style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Customer Outreach​',
		'/customer-outreach',
		<TbSpeakerphone style={{ fontSize: '18px' }} />,
	),
	getItem(
		'China RFQ Queue',
		'/rfq-queue',
		<TbFileStack style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Chipsfinder Logs',
		'/chipsfinder-logs',
		<FaMicrochip style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Customer Report',
		'/customer-report',
		<TbReportMoney style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Eagle: Customer RFQs',
		'/customer-rfqs',
		<span style={{ fontWeight: 'bold', fontSize: '10px' }}>RFQ</span>,
	),
	getItem(
		'Eagle Bobcat Match',
		'/eagle-bobcat-match',
		<GiLion style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Email Engagement',
		'/email-engagement',
		<MdEmail style={{ fontSize: '18px' }} />,
	),
	getItem(
		'External Emails',
		'/external-emails',
		<SiGmail style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Franchise Queue',
		'/franchise-queue',
		<HiMiniRectangleStack style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Franchised line Pricebook',
		'/franchised-line-pricebook',
		<MdPriceChange style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Freight/MOV by Supplier',
		'/freight-by-supplier',
		<FcInTransit style={{ fontSize: '20px' }} />,
	),
	getItem('Learn Centre', '/learn-centre', <FaBook />),
	getItem(
		'House Accounts',
		'/house-accounts',
		<img src={HouseAccount} alt="House Account" style={{ width: '20px' }} />,
	),
	getItem(
		'Management Reports​',
		'/management-report',
		<TbReport style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Mass Mail​',
		'/mass-mail',
		<FaMailBulk style={{ fontSize: '18px' }} />,
	),
	getItem(
		'Raven: Bulk Mass Email',
		'/raven',
		<FaMailBulk style={{ fontSize: '18px' }} />,
	),
	getItem(
		'MPN Queue',
		'/mpn-queue',
		<HiOutlineQueueList style={{ fontSize: '18px' }} />,
	),
	getItem(
		'MPN Report',
		'/mpn-report',
		<IoMdPricetags style={{ fontSize: '18px' }} />,
	),
	getItem(
		'MPN Substitute',
		'/mpn-substitution',
		<TbReplace style={{ fontSize: '18px' }} />,
	),
	getItem(
		'My Assigned Accounts​',
		'/assign-to-house',
		<img src={HouseAccount} alt="House Account" style={{ width: '20px' }} />,
	),
	getItem(
		'My Customer Contacts',
		'/customer-contacts',
		<RiContactsFill style={{ fontSize: '18px' }} />,
	),
	getItem(
		'My Past Emails',
		'/past-emails',
		<PiMicrosoftOutlookLogoFill style={{ fontSize: '18px' }} />,
	),
	// getItem(
	// 	'Net Components',
	// 	'/netcomponents',
	// 	<img src={netCompIcon} alt="Net Component" />
	// ),
	getItem(
		'Order Management',
		'/order-management',
		<TbShoppingCartDollar style={{ fontSize: '18px' }} />,
	),
	getItem(
		'PO Extractor',
		'/order-management?view=po-extractor',
		<TbFileInvoice style={{ fontSize: '18px' }} />,
	),
	getItem('Suppliers by Brand', '/supplier-sales-by-brand', <SiBrandfolder />),
	getItem(
		'Price Book',
		'/price-book',
		<MdPriceChange style={{ fontSize: '18px' }} />,
	),
	getItem('SO Backorders', '/so-backorders', <BsBoxSeamFill />),
	getItem(
		'Supplier Contacts',
		'/supplier-contacts',
		<RiContactsBook2Fill style={{ fontSize: '18px' }} />,
	),
	getItem('SCI Inventory', '/sci-inventory', <BsBoxSeamFill />),

	// getItem(
	// 	'MPN Cost Book',
	// 	'/mpn-cost-book',
	// 	<MdOutlinePriceChange style={{ fontSize: '18px' }} />
	// ),
	getItem(
		'Admin',
		'/admin',
		<MdOutlineAdminPanelSettings style={{ fontSize: '20px' }} />,
		[
			getItem('Account Allocation Log', '/admin/account-allocation-log'),
			getItem('API Health Checker', '/admin/api-health-checker'),
			getItem('API Token Limits', '/admin/api-token-limits'),
			getItem('ChatGPT Usage Report', '/admin/chatgpt-usage-report'),
			getItem('ChipsFinder Sources', '/admin/chipfinder-sources'),
			getItem(
				'Customer Outreach Threshold',
				'/admin/customer-outreach-threshold',
			),
			getItem('Price Book Logs', '/admin/eagle-price-book-email-logs'),
			getItem('Exclusion Manager', '/admin/bobcat-eagle-exclusions-list'),
			getItem('Franchised Brands', '/admin/franchised-brands'),
			getItem('Global ChatGPT Report', '/admin/global-chatgpt-report'),
			getItem('Header Identifiers', '/admin/chatgpt-keywords'),
			getItem('House Account - Admin', '/admin/house-account'),
			getItem('House Account Exclusion', '/admin/house-account-exclusion'),
			getItem('Inventory Engine', '/admin/inventory-engine'),
			getItem('Leads Exclusion', '/admin/leads-exclusion'),
			getItem('LinkedIn Cleanser', '/admin/linkedin-cleanser'),
			getItem('MailBox Storage Details', '/admin/mailbox-stroage-details'),
			getItem('Sales Report Tracker', '/admin/sales-report-tracker'),
			getItem('Section Access', '/admin/section-access'),
			getItem('Sourcing Assignments', '/admin/sourcing-assignments'),
			getItem('SR Accounts Summary', '/admin/sr-accounts-summary'),
			getItem('Tagging System', '/admin/eagle-processor-account-tags'),
			getItem('VSR Dashboard', '/admin/vsr-dashboard'),
			getItem('Website Leads', '/admin/website-leads'),
		],
	),
];

// Filter function
export const filterMenuItems = (menuItems, allowedRoutes) => {
	return menuItems
		.map((item) => {
			if (item.children) {
				const filteredChildren = filterMenuItems(item.children, allowedRoutes);
				if (filteredChildren.length > 0) {
					return { ...item, children: filteredChildren };
				}
				return null;
			} else {
				const basePath = item.key.split('?')[0];
				return allowedRoutes.includes(basePath) ? item : null;
			}
		})
		.filter((item) => item !== null);
};

export const backorderSitesData = [
	{
		id: 1,
		type: 'Distributor',
		name: 'Element 14',
		hyperlink: 'https://sg.element14.com/',
	},
	{
		id: 2,
		type: 'Distributor',
		name: 'Digikey',
		hyperlink: 'www.digikey.com',
	},
	{
		id: 3,
		type: 'Distributor',
		name: 'Mouser',
		hyperlink: 'www.mouser.sg',
	},
	{
		id: 4,
		type: 'Distributor',
		name: 'TME',
		hyperlink: 'https://www.tme.eu/',
	},
	{
		id: 5,
		type: 'Distributor',
		name: 'Avnet USA',
		hyperlink: 'http://www.avnet.com',
	},
	{
		id: 6,
		type: 'Distributor',
		name: 'Avnet Europe',
		hyperlink: 'https://www.avnet.com/wps/portal/emea/',
	},
	{
		id: 7,
		type: 'Distributor',
		name: 'Avnet Asia',
		hyperlink: 'https://www.avnet.com/wps/portal/apac',
	},
	{
		id: 8,
		type: 'Distributor',
		name: 'Heilind Electronics',
		hyperlink: 'www.heilind.com',
	},
	{
		id: 9,
		type: 'Distributor',
		name: 'Heilind Europe',
		hyperlink: 'https://www.heilind.de/',
	},
	{
		id: 10,
		type: 'Distributor',
		name: 'Heilind Asia',
		hyperlink: 'www.heilindasia.com',
	},
	{
		id: 11,
		type: 'Distributor',
		name: 'Future Electronics',
		hyperlink: 'https://www.futureelectronics.com/',
	},
	{
		id: 12,
		type: 'Distributor',
		name: 'TTI USA',
		hyperlink: 'http://www.ttiofusa.com/',
	},
	{
		id: 13,
		type: 'Distributor',
		name: 'TTI Europe',
		hyperlink: 'https://www.ttieurope.com/',
	},
	{
		id: 14,
		type: 'Distributor',
		name: 'TTI Asia',
		hyperlink: 'https://www.ttiasia.com/',
	},
	{
		id: 15,
		type: 'Distributor',
		name: 'Newark',
		hyperlink: 'http://www.newark.com',
	},
	{
		id: 16,
		type: 'Distributor',
		name: 'Farnell',
		hyperlink: 'https://uk.farnell.com',
	},
	{
		id: 17,
		type: 'Distributor',
		name: 'Anglia',
		hyperlink: 'https://www.anglia.com.sg',
	},
	{
		id: 18,
		type: 'Distributor',
		name: 'Allied Electronics',
		hyperlink: 'http://www.ex-en.alliedelec.com',
	},
	{
		id: 19,
		type: 'Distributor',
		name: 'RS Components',
		hyperlink: 'http://www.sg.rs-online.com',
	},
	{
		id: 20,
		type: 'Distributor',
		name: 'Rochester Electronics',
		hyperlink: 'https://www.rocelec.com/',
	},
	{
		id: 21,
		type: 'Distributor',
		name: 'Corestaff',
		hyperlink: 'https://corestaff.co.jp/cms/en/index.html',
	},
	{
		id: 22,
		type: 'Distributor',
		name: 'Master Electronics',
		hyperlink: 'https://www.masterelectronics.com/en/',
	},
	{
		id: 23,
		type: 'IDM',
		name: 'Microchip',
		hyperlink:
			'https://www.microchipdirect.com/product/MIC5801YWM-TR?productLoaded=true',
	},
	{
		id: 24,
		type: 'IDM',
		name: 'Maxim',
		hyperlink:
			'https://www.maximintegrated.com/en/products/power/switching-regulators/MAX15303.html#order-quality',
	},
	{
		id: 25,
		type: 'IDM',
		name: 'STM',
		hyperlink: 'https://estore.st.com/en/catalogsearch/result/?q=ULN2803A',
	},
	{
		id: 26,
		type: 'IDM',
		name: 'Renesas',
		hyperlink:
			'https://www.renesas.com/sg/en/buy-sample/check-inventory/result?partno=R5F21256SNFP%23V2',
	},
	{
		id: 27,
		type: 'IDM',
		name: 'Samtec',
		hyperlink:
			'https://wwws.samtec.com//my-samtec/pricing.aspx?partnumber=slw-106-01-l-s',
	},
	{
		id: 28,
		type: 'IDM',
		name: 'CoilCraft',
		hyperlink: 'https://www.coilcraft.com/',
	},
];

export const curriencies = [
	{ code: 'AED', name: 'United Arab Emirates Dirham' },
	{ code: 'AFN', name: 'Afghan Afghani' },
	{ code: 'ALL', name: 'Albanian Lek' },
	{ code: 'AMD', name: 'Armenian Dram' },
	{ code: 'ANG', name: 'Netherlands Antillean Guilder' },
	{ code: 'AOA', name: 'Angolan Kwanza' },
	{ code: 'ARS', name: 'Argentine Peso' },
	{ code: 'AUD', name: 'Australian Dollar' },
	{ code: 'AWG', name: 'Aruban Florin' },
	{ code: 'AZN', name: 'Azerbaijani Manat' },
	{ code: 'BAM', name: 'Bosnia-Herzegovina Convertible Mark' },
	{ code: 'BBD', name: 'Barbadian Dollar' },
	{ code: 'BDT', name: 'Bangladeshi Taka' },
	{ code: 'BGN', name: 'Bulgarian Lev' },
	{ code: 'BHD', name: 'Bahraini Dinar' },
	{ code: 'BIF', name: 'Burundian Franc' },
	{ code: 'BMD', name: 'Bermudan Dollar' },
	{ code: 'BND', name: 'Brunei Dollar' },
	{ code: 'BOB', name: 'Bolivian Boliviano' },
	{ code: 'BRL', name: 'Brazilian Real' },
	{ code: 'BSD', name: 'Bahamian Dollar' },
	{ code: 'BTC', name: 'Bitcoin' },
	{ code: 'BTN', name: 'Bhutanese Ngultrum' },
	{ code: 'BWP', name: 'Botswanan Pula' },
	{ code: 'BYN', name: 'Belarusian Ruble' },
	{ code: 'BYR', name: 'Belarusian Ruble' },
	{ code: 'BZD', name: 'Belize Dollar' },
	{ code: 'CAD', name: 'Canadian Dollar' },
	{ code: 'CDF', name: 'Congolese Franc' },
	{ code: 'CHF', name: 'Swiss Franc' },
	{ code: 'CLF', name: 'Chilean Unit of Account (UF)' },
	{ code: 'CLP', name: 'Chilean Peso' },
	{ code: 'CNY', name: 'Chinese Yuan' },
	{ code: 'COP', name: 'Colombian Peso' },
	{ code: 'CRC', name: 'Costa Rican Colón' },
	{ code: 'CUC', name: 'Cuban Convertible Peso' },
	{ code: 'CUP', name: 'Cuban Peso' },
	{ code: 'CVE', name: 'Cape Verdean Escudo' },
	{ code: 'CZK', name: 'Czech Republic Koruna' },
	{ code: 'DJF', name: 'Djiboutian Franc' },
	{ code: 'DKK', name: 'Danish Krone' },
	{ code: 'DOP', name: 'Dominican Peso' },
	{ code: 'DZD', name: 'Algerian Dinar' },
	{ code: 'EEK', name: 'Estonian Kroon' },
	{ code: 'EGP', name: 'Egyptian Pound' },
	{ code: 'ERN', name: 'Eritrean Nakfa' },
	{ code: 'ETB', name: 'Ethiopian Birr' },
	{ code: 'EUR', name: 'Euro' },
	{ code: 'FJD', name: 'Fijian Dollar' },
	{ code: 'FKP', name: 'Falkland Islands Pound' },
	{ code: 'GBP', name: 'British Pound Sterling' },
	{ code: 'GEL', name: 'Georgian Lari' },
	{ code: 'GHS', name: 'Ghanaian Cedi' },
	{ code: 'HKD', name: 'Hong Kong Dollar' },
	{ code: 'IDR', name: 'Indonesian Rupiah' },
	{ code: 'ILS', name: 'Israeli New Sheqel' },
	{ code: 'INR', name: 'Indian Rupee' },
	{ code: 'JPY', name: 'Japanese Yen' },
	{ code: 'KRW', name: 'South Korean Won' },
	{ code: 'MXN', name: 'Mexican Peso' },
	{ code: 'MYR', name: 'Malaysian Ringgit' },
	{ code: 'NGN', name: 'Nigerian Naira' },
	{ code: 'NOK', name: 'Norwegian Krone' },
	{ code: 'NZD', name: 'New Zealand Dollar' },
	{ code: 'PHP', name: 'Philippine Peso' },
	{ code: 'PKR', name: 'Pakistani Rupee' },
	{ code: 'RUB', name: 'Russian Ruble' },
	{ code: 'SAR', name: 'Saudi Riyal' },
	{ code: 'SGD', name: 'Singapore Dollar' },
	{ code: 'THB', name: 'Thai Baht' },
	{ code: 'TRY', name: 'Turkish Lira' },
	{ code: 'USD', name: 'United States Dollar' },
	{ code: 'VND', name: 'Vietnamese Dong' },
	{ code: 'ZAR', name: 'South African Rand' },
];
